import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchProductionWorkOrderAutocompleteList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/production/autocomplete.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {

            let response = []
            if(res.data.response) {
                response = res.data.response.filter((thing, index, self) =>
                    index === self.findIndex((t) => (t.id === thing.id))
                )
            }
            if(res.data.try_again) {
            } else {
                commit('setProductionAutoCompleteList', response)         
            }

        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const convertToInventory = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/saleDelivery/convertToInventory.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const putProductionOrderOnHold = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/production/putProductionOrderOnHold.php', payload.item_list, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            dispatch('fetchProductionWorkOrderAutocompleteList', payload.master_payload)
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchProductionWorkerWorkStatus = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/production/workerStatus.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
            } else {
                commit('setProductionWorkerWorkStatus', res.data.response)         
            }

        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchProductionProcessBatchList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/production/processBatch/Index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setProductionProcessBatchList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const fetchProductionWorkOrderList = ({commit}, payload) => {
    
    if(!payload.order_display_window) {
        commit('toggleLoadingState', true)
    }

    axios.post('/production/workOrderList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        //console.log(JSON.stringify(res.data))
        let response = []
        if(res.data.response) {
            response = res.data.response.filter((thing, index, self) =>
                index === self.findIndex((t) => (t.id === thing.id))
            )
        }
        let store_query = false
        if(payload.store_query) {
            store_query = payload.store_query
        }
        commit('setProductionWorkOrderList', {response: response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number, store_query})   
        if(payload.list_type == 'process_batch' && parseInt(payload.page_number) === 1) {
            router.push('/processbatch/list?list_type=process_batch&process_id='+payload.process_id+'&workshop_id='+payload.workshop_id)
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const fetchProductionGroupWorkOrderList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/production/workOrderGroupList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setProductionGroupWorkOrderList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})   
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const fetchWorkOrderAssignmentHistory = ({commit}, payload) => {
        
    commit('toggleLoadingState', true)

    axios.post('/production/workOrderAssignment/assignmentHistory.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        console.log(JSON.stringify(res.data.response))
        commit('setProductionWorkOrderAssignmentHistory', res.data.response)   
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const updateWorkOrderAssignmentHistory = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/production/workOrderAssignment/updateHistory.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
        } else {
            commit('displayMessageAlert', {message: 'Error, please try again!!!', type: 'Error'})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const updateFabricQtyFromWorkOrder = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/production/updateFabricQtyFromWorkOrder.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
        } else {
            commit('displayMessageAlert', {message: 'Error, please try again!!!', type: 'Error'})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const updateWorkOrderAssignment = ({commit, dispatch}, payload) => {
    
    //console.log(JSON.stringify(payload))
    //return
    commit('toggleLoadingState', true)

    axios.post('/production/workOrderAssignment/updateAssignment.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        //return
        console.log(JSON.stringify(res.data))
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.personal_list && payload.personal_list !== null) {
                //dispatch('fetchProductionWorkOrderList', payload.personal_list)
                commit('updateWorkOrderAssignment_WorkStatus', res.data)
            } else {
                if(res.data.production_row === null && payload.listSearch) {
                    dispatch('fetchProductionWorkOrderList', payload.listSearch)
                } else {
                    commit('updateWorkOrderAssignment_WorkStatus', res.data)
                }
            }
            
        } else {
            commit('displayMessageAlert', {message: 'Error, please try again!!!', type: 'Error'})
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const fetchWorkerHistory = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/production/workOrderAssignment/workerHistory.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setProductionWorkerHistory', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const loadReadyOrders = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/planner/readyOrders.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setReadyOrderList', res.data.response)

        setTimeout(() => {
            commit('toggleLoadingState', false)
        }, 2000);
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        //commit('toggleLoadingState', false)
    })

}

export const openCustomerOrderDetails_ProductionStageWise = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/planner/openCustomerOrderDetails_ProductionStageWise.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        let response = []
        if(res.data.response) {
            response = res.data.response.filter((thing, index, self) =>
                index === self.findIndex((t) => (t.id === thing.id))
            )
        }
        commit('setReadyOrderList_DetailList', response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const notifyCustomerForReadyItems = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/planner/notifyCustomerForReadyItems.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('displaySuccessNotification', {message: 'Notified successfully!!!'});
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const updateScheduledDate = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/planner/updateScheduledDate.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('mutate_SetReadyOrderList_DetailList', res.data.response)
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.show_detail) {
                //dispatch('openCustomerOrderDetails_ProductionStageWise', {customer_id: payload.customer_id})
            }                        
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const updatePriority = ({commit}, payload) => {
        
    commit('toggleLoadingState', true)

    axios.post('/planner/updatePriority.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});            
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const restartProductionProcess = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/planner/restartProductionProcess.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('updateWorkOrderAssignment_WorkStatus', res.data)   
        dispatch('fetchWorkOrderAssignmentHistory', {production_id: payload.production_id})        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const loadPlannerData = ({commit}, payload) => {
            
    commit('toggleLoadingState', true)
    
    axios.post('/planner/loadPlannerData.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setLoadPlannerData', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const workOrderLoad = ({commit}, payload) => {
        
    commit('toggleLoadingState', true)
    
    axios.post('/workOrder/workOrderLoad.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setWorkOrderLoad', {sale_item_id: payload.sale_item_id, tailoring_item_id: payload.tailoring_item_id, list: res.data.response})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const removeWorkOrderTrial = ({commit}, payload) => {
        
    commit('toggleLoadingState', true)
    
    axios.post('/workOrder/removeWorkOrderTrial.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        commit('unsetWorkOrderTrial', payload.production_id)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const markWorkOrderTrial = ({commit}, payload) => {
        
    commit('toggleLoadingState', true)
    
    axios.post('/workOrder/markWorkOrderTrial.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('setWorkOrderTrial', payload)
        }        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const approveWorkOrderTrial = ({commit}, payload) => {
        
    commit('toggleLoadingState', true)
    
    axios.post('/workOrder/approveWorkOrderTrial.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('setWorkOrderTrialApproval', payload.production_id)
        }        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const emailProcessBatch = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displayMessageAlert', {message: 'Admin will receive an email in a few minutes, it may take upto 15 mins or more.', type: 'Info'})
        commit('toggleLoadingState', false)
    }, 1000);
    axios.post('/production/processBatch/emailProcessBatch.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        console.log(JSON.stringify(res.data))
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchWorkOrderSubProcessList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/production/fetchWorkOrderSubProcessList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setProductionWorkSubProcessList', {response: res.data.response, queryPayload: payload})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateWorkOrderAssignmentSubProcess = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/production/workOrderAssignment/updateAssignmentSubProcess.php', payload.postDataLoad, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        //console.log(JSON.stringify(res.data))
        dispatch('fetchWorkOrderSubProcessList', payload.masterPayload)
        if(payload.postDataLoad.last_sub_process === 1) {
            dispatch('updateWorkOrderAssignment', payload.finalFinishPayload)
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        //commit('toggleLoadingState', false)
    })
}



// WEBPACK FOOTER //
// ./src/store/modules/production/actions.js